{
  "intro": "Сетевые диски проекта: объём от 10\u00a0ГБ до 10\u00a0ТБ, который подключается к серверу той же локации и переживает его. Диск оплачивается за весь объём каждый месяц, подключён он или нет; увеличить его можно, уменьшить — нет.",
  "empty": "Дисков пока нет",
  "emptyLead": "Диск добавляет серверу место сверх его собственного диска: для баз данных, файлов, бэкапов. Данные на диске остаются, когда сервер пересоздают или удаляют.",
  "create": "Создать диск",
  "createLead": "Новый диск в локации или сразу на сервере.",
  "createSubmit": "Создать диск",
  "created": "Диск {{name}} создаётся",
  "name": "Название",
  "nameHint": "Латинские буквы, цифры, точки, дефисы и подчёркивания, до 64 символов.",
  "size": "Объём, ГБ",
  "sizeHint": "От {{min}} до {{max}}\u00a0ГБ. Потом объём можно только увеличить.",
  "sizeGb": "{{size}}\u00a0ГБ",
  "priceLine": "{{price}} в месяц: {{size}}\u00a0ГБ × {{perGb}} за ГБ.",
  "billing": "Диск оплачивается с момента создания и до удаления — за весь объём, подключён он к серверу или нет. Удалённый диск и его данные восстановить нельзя.",
  "where": "Куда",
  "keepFree": "Создать в локации, без сервера",
  "onServer": "Сразу подключить к серверу",
  "location": "Локация",
  "locationHint": "Диск можно подключить только к серверу этой же локации.",
  "zone": "Сетевая зона {{zone}}",
  "server": "Сервер",
  "chooseServer": "Выберите сервер",
  "serverHint": "Диск подключается к серверу той же локации без выключения. К одному серверу — до {{max}} дисков.",
  "format": "Файловая система",
  "formatNone": "Без файловой системы",
  "formatNoneHint": "Пустое устройство: разметьте и отформатируйте его на сервере сами.",
  "formatExt4Hint": "Подходит почти всегда.",
  "formatXfsHint": "Для больших файлов и баз данных.",
  "automount": "Смонтировать автоматически",
  "automountHint": "На системах Hetzner диск сам появится в /mnt/HC_Volume_<номер>. Нужна файловая система.",
  "fs": "ФС",
  "noFs": "нет",
  "device": "Устройство",
  "notAttached": "Не подключён",
  "creating": "Создаётся",
  "protected": "Защищён",
  "flags": "Свойства",
  "price": "В месяц",
  "createdAt": "Создан",
  "attach": "Подключить к серверу",
  "attachTitle": "Подключить {{name}} к серверу",
  "attachLead": "Сервер должен быть в той же локации ({{region}}). Выключать его не нужно. На сервере диск появится как {{device}}.",
  "attaching": "Подключаем {{name}}",
  "detach": "Отключить от сервера",
  "detachTitle": "Отключить {{name}} от {{server}}?",
  "detachUnmount": "Сначала отмонтируйте диск на сервере (umount), иначе последние записи могут потеряться.",
  "detachKept": "Данные на диске сохранятся; его можно будет подключить к другому серверу этой локации.",
  "detachBilling": "Отключённый диск оплачивается так же, как подключённый.",
  "detaching": "Отключаем {{name}}",
  "resize": "Увеличить объём",
  "resizeTitle": "Увеличить {{name}}",
  "resizeLead": "Сейчас {{size}}\u00a0ГБ. Объём можно только увеличить: уменьшить диск нельзя.",
  "newSize": "Новый объём, ГБ",
  "newSizeHint": "Больше {{size}}\u00a0ГБ, до {{max}}\u00a0ГБ.",
  "newPrice": "Будет {{price}} в месяц вместо {{old}}.",
  "resizeExt4": "Затем расширьте файловую систему на сервере: resize2fs {{device}}",
  "resizeXfs": "Затем расширьте файловую систему на сервере: xfs_growfs <точка монтирования>",
  "resizeRaw": "Затем расширьте разделы и файловую систему на сервере.",
  "resizeSubmit": "Увеличить",
  "resizing": "Увеличиваем {{name}} до {{size}}\u00a0ГБ",
  "edit": "Имя и метки",
  "editTitle": "Имя и метки {{name}}",
  "labels": "Метки",
  "labelsHint": "По одной на строку: ключ=значение.",
  "labelsInvalid": "Строка {{line}}: ключ и значение — до 63 латинских букв, цифр, точек, дефисов и подчёркиваний.",
  "protect": "Включить защиту от удаления",
  "unprotect": "Снять защиту от удаления",
  "delete": "Удалить",
  "deleteTitle": "Удалить диск {{name}}?",
  "deleteData": "Все данные на диске будут уничтожены, восстановить их нельзя.",
  "deleteBilling": "Оплата за диск прекратится.",
  "deleted": "Диск {{name}} удалён",
  "why": {
    "attached": "Уже подключён к серверу {{server}}: сначала отключите его.",
    "notAttached": "Диск никуда не подключён.",
    "creating": "Диск ещё создаётся.",
    "protected": "Включена защита от удаления: сначала снимите её.",
    "deleteAttached": "Диск подключён к серверу: сначала отключите его.",
    "otherRegion": "другая локация",
    "full": "уже {{count}} дисков",
    "atMax": "Больше {{max}}\u00a0ГБ диск быть не может."
  },
  "serverTab": {
    "title": "Диски сервера",
    "lead": "Сетевые диски, подключённые к этому серверу. Их данные переживают пересоздание и удаление сервера.",
    "empty": "К серверу не подключён ни один диск.",
    "attachExisting": "Подключить диск",
    "createNew": "Создать диск",
    "chooseVolume": "Свободный диск",
    "chooseVolumePlaceholder": "Выберите диск",
    "noneFree": "В локации {{region}} нет свободных дисков. Создайте новый.",
    "manage": "Все диски проекта",
    "mount": "Смонтирован автоматически в /mnt/HC_Volume_{{id}}, если включали автомонтирование."
  }
}
